import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/user-star.png'


const _withScopeId = n => (_pushScopeId("data-v-3c3bc866"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "good" }
const _hoisted_2 = { class: "left-list" }
const _hoisted_3 = { class: "good-header" }
const _hoisted_4 = { class: "good-header-avatar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "star",
  src: _imports_0
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "good-line" }, null, -1))
const _hoisted_7 = { class: "good-name" }
const _hoisted_8 = { class: "right-list" }
const _hoisted_9 = { class: "good-header" }
const _hoisted_10 = { class: "good-header-avatar" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "star",
  src: _imports_0
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "good-line" }, null, -1))
const _hoisted_13 = { class: "good-name" }

import {
  ref,
  reactive,
  onMounted,
  watch,
  nextTick,
} from 'vue'
import { useRect } from '@vant/use'
import MImage from '@/components/MImage/MImage.vue'
import MTabs from '@/components/MTabs/MTabs.vue'
import MTabs2 from '@/components/MTabs2/MTabs2.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MWaterFall',
  props: {
  listData: { type: Array },
},
  emits: ['onSendHeight'],
  setup(__props, { emit: emits }) {

const props = __props;



const goodsListRef = ref(null)
const state = reactive({
  waterfallArr: props.listData,
  array: [], //定义空数组存储元素高度
  leftList: [],
  rightList: [],
})

onMounted(() => {
  // setTimeout(() => {
  //   // 防止图片高度没有加载出来
  //   getWaterfall()
  // }, 100)
  getWaterfall()
})

watch(
  () => props.listData,
  (newValue, oldValue) => {
    state.waterfallArr = newValue
    state.array = []
    getWaterfall()
    // setTimeout(() => {
    // }, 100)
  }
)

const getWaterfall = () => {
  state.leftList = []
  state.rightList = []
  if (state.waterfallArr.length === 0) return
  state.waterfallArr.forEach((item, index) => {
    if (index % 2 === 0) {
      state.leftList.push(item)
    } else {
      state.rightList.push(item)
    }
  })
  nextTick(() => {
    const rect = useRect(goodsListRef)
    // console.log('containerHeight==>', rect)
    // goodsListRef.value.style.height = containerHeight + 'px' // 设置容器高度
    emits('onSendHeight', rect.height)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "goodsListRef",
    ref: goodsListRef,
    class: "goods"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.leftList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "good-content"
          }, [
            _createVNode(_component_router_link, {
              to: { path: `/business-card/${item.employeeId}` }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(MImage, {
                      type: "avatar",
                      class: "avatar",
                      src: item.headImg
                    }, null, 8, ["src"]),
                    _hoisted_5
                  ]),
                  _createVNode(MTabs, {
                    tabs: item.employeeLabel
                  }, null, 8, ["tabs"])
                ])
              ]),
              _: 2
            }, 1032, ["to"]),
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: `/goods-detail/${item.id}`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.goodsName), 1),
                _createVNode(MTabs2, {
                  tabs: item.goodsLables
                }, null, 8, ["tabs"])
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.rightList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "good-content"
          }, [
            _createVNode(_component_router_link, {
              to: { path: `/business-card/${item.employeeId}` }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(MImage, {
                      type: "avatar",
                      class: "avatar",
                      src: item.headImg
                    }, null, 8, ["src"]),
                    _hoisted_11
                  ]),
                  _createVNode(MTabs, {
                    tabs: item.employeeLabel
                  }, null, 8, ["tabs"])
                ])
              ]),
              _: 2
            }, 1032, ["to"]),
            _hoisted_12,
            _createVNode(_component_router_link, {
              to: `/goods-detail/${item.id}`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, _toDisplayString(item.goodsName), 1),
                _createVNode(MTabs2, {
                  tabs: item.goodsLables
                }, null, 8, ["tabs"])
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ])
  ], 512))
}
}

})